export default {
	apiUrlBase: 'https://app.restorani.bitlab.host',
	apiUrl: 'https://app.restorani.bitlab.host/api'
}